import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/categories',
      method: 'get',
      params: params
  })
}

export function show(id) {
  return request({
      url: `/settings/categories/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/categories',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/categories/${data.id}`,
      method: 'put',
      data
  })
}


export function inventory(params) {
  return request({
      url: '/settings/category/inventory',
      method: 'get',
      params
  })
}

export function destroy(id) {
  return request({
      url: `/settings/categories/${id}`,
      method: 'delete',
  })
}
